import {makeAction, makeAsyncAction} from 'common/utils/simplifiedAsync';

const ACTION_PREFIX = 'anodot/trainTracker/';
const mac = (actionName) => makeAction(actionName, ACTION_PREFIX);
const macAsync = (actionName) => makeAsyncAction(actionName, ACTION_PREFIX);

export const fetchTrainTrackerData = macAsync('FETCH_TRAIN_TRACKER_DATA');
export const setPageKeyVal = mac('SET_TRAIN_TRACKER_KEY_VAL');
